import * as React from "react";
const SvgSecurity = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path d="M15.53 10.53a.75.75 0 1 0-1.06-1.06L11 12.94l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l4-4Z" />
      <path d="M12.27 2.05a.75.75 0 0 0-.54 0L5.256 4.557A2.75 2.75 0 0 0 3.5 7.12v5.86a6.75 6.75 0 0 0 3.09 5.673l5.003 3.227a.75.75 0 0 0 .814 0l5.002-3.227A6.75 6.75 0 0 0 20.5 12.98V7.12a2.75 2.75 0 0 0-1.757-2.565L12.27 2.05ZM5.8 5.956 12 3.555l6.201 2.4c.482.186.799.65.799 1.165v5.86a5.25 5.25 0 0 1-2.404 4.412L12 20.358l-4.596-2.966A5.25 5.25 0 0 1 5 12.981V7.12c0-.517.317-.98.799-1.166Z" />
    </g>
  </svg>
);
export default SvgSecurity;
